/**
 * 모델
 * @window w_tb_da451w_01
 * @category 설치견적현황
 */
export default class StatusDateModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(8)
   */
  readonly actnm: string;

  /**
   * 공사명
   *
   * **data type** varchar(8)
   */
  readonly constnm: string;

  /**
   * 계약구분
   *
   * **data type** varchar(8)
   */
  readonly contflag: string;

  /**
   * 견적일자
   *
   * **data type** varchar(8)
   */
  readonly costdate: string;

  /**
   * 견적명
   *
   * **data type** varchar(8)
   */
  readonly costnum: string;

  /**
   * 견적담당자
   *
   * **data type** varchar(8)
   */
  readonly costperid: string;

  /**
   * 견적담당자명
   *
   * **data type** varchar(8)
   */
  readonly costpernm: string;

  /**
   * 견적번호
   *
   * **data type** varchar(8)
   */
  readonly costseq: string;

  /**
   * 매출구분
   *
   * **data type** varchar(8)
   */
  readonly gubun: string;

  /**
   * 제어반
   *
   * **data type** varchar(8)
   */
  readonly jeoban: string;

  /**
   * 금액
   *
   * **data type** varchar(8)
   */
  readonly mamt: string;

  /**
   * 월
   *
   * **data type** varchar(8)
   */
  readonly mon: string;

  /**
   * 부가세여부
   *
   * **data type** varchar(8)
   */
  readonly myn: string;

  /**
   * 인승
   *
   * **data type** varchar(8)
   */
  readonly nperson: string;

  /**
   * 층수
   *
   * **data type** varchar(8)
   */
  readonly number: string;

  /**
   * 품목코드
   *
   * **data type** varchar(8)
   */
  readonly pcode: string;

  /**
   * 품명
   *
   * **data type** varchar(8)
   */
  readonly pname: string;

  /**
   * 규격
   *
   * **data type** varchar(8)
   */
  readonly psize: string;

  /**
   * 수량
   *
   * **data type** varchar(8)
   */
  readonly qty: string;

  /**
   * 단가
   *
   * **data type** varchar(8)
   */
  readonly samt: string;

  /**
   * 부가세
   *
   * **data type** varchar(8)
   */
  readonly tamt: string;

  /**
   * 공급가액
   *
   * **data type** varchar(8)
   */
  readonly uamt: string;

  /**
   * 상태
   *
   * **data type** varchar(8)
   */
  readonly state: string;

  contflagnm: string;


  constructor(data: any = {}) {
    this.custcd = data.custcd || '';
    this.actnm = data.actnm || '';
    this.constnm = data.constnm || '';
    this.contflag = data.contflag || '';
    this.costdate = data.costdate || '';
    this.costnum = data.costnum || '';
    this.costperid = data.costperid || '';
    this.costpernm = data.costpernm || '';
    this.costseq = data.costseq || '';
    this.gubun = data.gubun || '';
    this.jeoban = data.jeoban || '';
    this.mamt = data.mamt || '';
    this.mon = data.mon || '';
    this.myn = data.myn || '';
    this.nperson = data.nperson || '';
    this.number = data.number || '';
    this.pcode = data.pcode || '';
    this.pname = data.pname || '';
    this.psize = data.psize || '';
    this.qty = data.qty || '';
    this.samt = data.samt || '';
    this.tamt = data.tamt || '';
    this.uamt = data.uamt || '';
    this.state = data?.state || '%';
    this.contflagnm = data.contflagnm || '';
  }
}
